import React from 'react';
import { Reward, RewardGrant, useI18n } from '@springbig/shared';
import dayjs from 'dayjs';
import RewardGrantCard, { RewardGrantCardSkeleton } from '~/shared/RewardGrantCard';
import { faGift, faStar, faGifts, faLock, faCoins } from '@fortawesome/free-solid-svg-icons';

export type DesiredAction = {
    id: number;
    name: string;
    rewards: Reward[];
    type_id: number;
};

type OffersCardProps = {
    rewardGrants?: RewardGrant[];
    handleAcceptRedeemReward?: (id: number, title: string) => void;
    handleBonusRewards?: (id: number) => void;
    rewardActiveId?: number | undefined;
    loadingActivation?: boolean;
    onGetOffer?: (typeId: number) => void;
    desiredActions?: DesiredAction[];
    isLoading: boolean;
};

const OffersCard = ({
    handleAcceptRedeemReward,
    handleBonusRewards,
    loadingActivation,
    rewardActiveId,
    rewardGrants,
    desiredActions,
    onGetOffer,
    isLoading
}:OffersCardProps) => {

    const { t } = useI18n();

    if (desiredActions?.length > 0) {

        return (desiredActions.filter((action) => [8, 9, 10].includes(action.type_id)).map((action) => {

            let bodyText = '';

            switch (action.type_id) {
            case 8:
                bodyText = t('general.birthday');
                break;
            case 9:
                bodyText = action?.name;
                break;
            case 10:
                bodyText = t('general.email');
                break;
            }

            let bonusType = '';

            if (action?.rewards?.length > 0) {
                switch (action.rewards[0].bonus_type) {
                case 'multiply':
                    bonusType = '*';
                    break;
                case 'addition':
                    bonusType = '+';
                    break;
                }
            }

            return (
                <RewardGrantCard
                    key={action.name}
                    prop={{
                        desiredAction: {
                            desiredAction: action,
                            onGetOffer,
                            titleIcon: faLock,
                            iconTitle: t('offers.unlock'),
                            leftIcon: faGifts,
                            bodyText,
                            subTitle: `${bonusType} ${action?.rewards[0]?.name}`
                        }
                    }}
                    type='desiredAction'
                />
            );
        }));
    }

    if (handleAcceptRedeemReward !== null && handleBonusRewards !== null && loadingActivation !== null) {
        return (rewardGrants && rewardGrants.length > 0 && rewardGrants.map((offer) => {

            const leftIcon = offer?._type === 'gift_card' ? faCoins : faStar;

            return (
                <RewardGrantCard
                    key={offer.id}
                    prop={{
                        reward: {
                            offer,
                            handleAcceptRedeemReward,
                            handleBonusRewards,
                            rewardActiveId,
                            loadingActivation,
                            titleIcon: faGift,
                            iconTitle: offer?._type === 'coupon'
                                ? 'offer'
                                : offer?._type,
                            leftIcon,
                            bodyText: offer?.reward?.name,
                            subTitle: offer?.expiration_short ? t('rewards.expires_at', [offer?.expiration_short]) : ''
                        }
                    }}
                    type='reward'
                />
            );
        }));
    }

    if (isLoading) {
        return <OffersCardSkeleton />;
    }

    return <></>;
};

export const OffersCardSkeleton = () =>

    Array.from({ length: 10 }, (_, index) => (

        <RewardGrantCardSkeleton key={index} />
    ));

export default OffersCard;
